module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-regular-dd90dff9396ee53e56e0a3c79b98c6f6.woff";